export const CHART_COLORS = [
    "#CAD238",
    "#008364",
    "#9cccc4",
];
